import { formatWithDelimiters } from './formatWithDelimiters'

/**
 * Formats a number of cents into a currency string using a Shopify format string.
 *
 * See https://help.shopify.com/en/manual/international/pricing/currency-formatting#currency-formatting-options.
 * Originally from: https://gist.github.com/stewartknapman/8d8733ea58d2314c373e94114472d44c.
 *
 * @param cents - The number of cents to format.
 * @param format - The format string to use.
 * @returns The formatted currency string.
 */
export const formatMoney = (cents: number, format: string): string => {
  return format.replace(/\{\{\s*(\w+)\s*\}\}/, (match, placeholder) => {
    switch (placeholder) {
      case 'amount': {
        // Ex.	1,134.65
        return formatWithDelimiters(cents, 2)
      }
      case 'amount_no_decimals': {
        // Ex. 1,135
        return formatWithDelimiters(cents, 0)
      }
      case 'amount_with_comma_separator': {
        // Ex. 1.134,65
        return formatWithDelimiters(cents, 2, '.', ',')
      }
      case 'amount_no_decimals_with_comma_separator': {
        // Ex. 1.135
        return formatWithDelimiters(cents, 0, '.', ',')
      }
      case 'amount_with_apostrophe_separator': {
        // Ex. 1'134.65
        return formatWithDelimiters(cents, 2, "'", '.')
      }
      case 'amount_no_decimals_with_space_separator': {
        // Ex. 1 135
        return formatWithDelimiters(cents, 0, ' ')
      }
      case 'amount_with_space_separator': {
        // 1 134,65
        return formatWithDelimiters(cents, 2, ' ', ',')
      }
      case 'amount_with_period_and_space_separator': {
        // 1 134.65
        return formatWithDelimiters(cents, 2, ' ', '.')
      }
      default: {
        return match
      }
    }
  })
}
